import gql from 'graphql-tag'

export const MAIL_PROCESSING_TEMPLATE_DELETE_MUTATION = gql`
    mutation mailProcessingTemplateDelete(
        $id: ID!
    ) {
        mailProcessingTemplateDelete(
            id: $id
        ) {
            status
        }
    }
`
